<template>
  <div class="h-auto ml-0 w-full lg:mr-3 min-h-screen">
    <div class="bg-white m-3 rounded-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold">List of events</p>

        <button
          @click="showAddAnEvent = true"
          class="bg-primary text-white rounded-full px-3 py-1 text-sm"
        >
          Create an Event
        </button>
      </div>
      <div>
        <transition name="fade">
          <div v-if="loading" class="inset-0 absolute z-50 bg-white w-full">
            <loader class="center-h-v" /></div
        ></transition>
        <div class="flex justify-between items-center p-2">
          <el-pagination
            background
            @size-change="handleSizeChange"
            :page-sizes="pageSizes"
            :page-index="pageIndex"
            :page-size="pageSize"
            layout="sizes"
            :total="currentTableData.length"
          >
          </el-pagination>
          <!-- search -->
          <input
            v-model="searchInput"
            type="search"
            placeholder="Start typing to search..."
            class="bg-gray-200 w-52 py-1 rounded-md"
          />
          <!-- search -->
        </div>
        <button></button>
      </div>
      <div class="p-2">
        <ve-table
          v-if="searchInput"
          :columns="columns"
          :table-data="filteredTableData"
          sort-order="asc"
        />

        <ve-table
          :columns="columns"
          :tableData="currentTableData"
          v-if="!searchInput.length"
        >
        </ve-table>

        <div
          v-else-if="
            (!loading || currentTableData.length === 0) && !searchInput.length
          "
          class="flex flex-col justify-center items-center h-full mt-5"
        >
          <el-empty :image-size="70" description="No Data"></el-empty>
        </div>

        <div
          v-else-if="searchInput.length && filteredTableData.length === 0"
          class="flex flex-col justify-center items-center h-full mt-5"
        >
          <img
            src="@/assets/icons/empty-folder-96.png"
            alt=""
            srcset=""
            class="animate-pulse"
          />
          <p>No results</p>
        </div>
      </div>
      <!-- Pagination -->
      <div class="table-pagination text-center mt-2">
        <!-- <ve-pagination :total="totalCount" :page-index="pageIndex" :page-size="pageSize"
              @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" :show-jumper="false" /> -->
        <el-pagination
          background
          layout="prev, pager, next"
          :total="totalCount"
          :page-size="pageSize"
          @current-change="handleCurrentChange"
        >
          <!-- :current-page.sync="currentPage4" -->
        </el-pagination>
      </div>
      <!-- Pagination -->
    </div>
    <!-- edit -->
    <editEvent
      @close="handleClose"
      :info="eventToEdit"
      :showeditEvent="showeditEvent"
      :reload="reload"
    >
    </editEvent>
    <!-- create -->
    <add-event
      @close="handleClose"
      :showAddAnEvent="showAddAnEvent"
      :reload="reload"
    ></add-event>
    <action-warning
      :message="message"
      :set-is-confirmed="setIsConfirmed"
      :show-warning="showWarning"
      @close="showWarning = false"
      :title="title"
    ></action-warning>
  </div>
</template>

<script>
import AddEvent from "@/components/events/addEvent.vue";
import axios from "axios";
import { mapGetters } from "vuex";
// import { utils, writeFileXLSX } from "xlsx";
import editEvent from "@/components/events/editEvent.vue";
import ActionWarning from "../utils/actionWarning.vue";
import Loader from "@/components/loader/loader.vue";
import moment from "moment";
//import { mapGetters } from "vuex";

export default {
  name: "Events",
  components: { AddEvent, Loader, editEvent, ActionWarning },

  data() {
    return {
      // page index
      pageIndex: 1,
      // page size
      pageSize: 10,
      pageSizes: [],
      showAddAnEvent: false,
      loading: false,
      searchInput: "",
      showeditEvent: false,
      get_error: null,
      create_success: null,
      del_document: null,
      del_success: null,
      del_error: null,
      info: null,
      message: null,
      title: null,
      eventToDelete: null,
      showActions: false,
      showWarning: false,
      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },

        { field: "Title", key: "Title", title: "Title", align: "left" },
        {
          field: "Description",
          key: "Description",
          title: "Description",
          align: "left",
          ellipsis: {
            showTitle: true,
          },
          renderBodyCell: ({ row }) => (
            <el-popover
              placement="top-start"
              title={"Leave request from " + row.Name}
              width="300"
              trigger="hover"
              content={row.Description}
            >
              <p
                slot="reference"
                class="cursor-pointer"
                styel="font-size: 0.68rem !important;"
              >
                {row.Description}
              </p>
            </el-popover>
          ),
        },
        {
          field: "StartDateTime",
          key: "StartDateTime",
          title: "Start Date",
          renderBodyCell: ({ row }) =>
            moment(row.StartDateTime).format("DD/MM/YY h:m a"),
          align: "left",
        },
        {
          field: "EndDateTime",
          key: "EndDate",
          title: "End Date",
          renderBodyCell: ({ row }) =>
            moment(row.EndDateTime).format("DD/MM/YY h:m a"),
          align: "left",
        },
        {
          field: "Location",
          key: "Location",
          title: "Location",
          align: "left",
        },
        {
          field: "EventType",
          key: "EventType",
          title: "Event Type",
          align: "left",
        },

        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="w-full text-left py-3 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleEditButtonClick(row)}
                >
                  Edit
                </button>
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleDeleteButtonClick(row)}
                >
                  Delete
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],
      upcommingEvent: [],
      tableData: [],
    };
  },
  created() {
    this.getEvents();

    this.setPageSizes();
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.tableData;
      } else {
        // Filter the tableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        return this.tableData.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    // table data
    currentTableData() {
      const { pageIndex, pageSize } = this;
      return this.tableData.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },
    // total count
    totalCount() {
      return this.tableData.length;
    },
  },
  methods: {
    open(message) {
      this.$notify({
        title: "Success",
        message: message,
        type: "success",
      });
    },
    reload(message) {
      this.getEvents();
      this.showeditEvent = false;
      this.open(message);
    },
    handleEditButtonClick(event) {
      // Handle the button click for the edit button

      this.eventToEdit = event;

      this.showeditEvent = true;
    },
    handleClose() {
      this.showAddAnEvent = false;
      this.showeditEvent = false;
    },
    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },
    handleDeleteButtonClick(event) {
      this.title = `Delete ${event.Title}`;
      this.message = `You are about to delete ${event.Title} from the events type list!`;
      this.eventToDelete = event;
      this.showWarning = true;
    },
    setIsConfirmed() {
      this.showWarning = false;
      if (this.eventToDelete) {
        this.deleteEvent(this.eventToDelete);
        return;
      }
    },
    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },
    deleteEvent(row) {
      //console.log(row)
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
        data: {
          EventId: row.Id,
        },
      };

      axios.delete(`${this.getOrganization}/event/v1/delete`, options).then(
        (response) => {
          //  console.log(response);
          this.loading = false;
          if (response.data.StatusCode == 200) {
            this.del_success = response.data.StatusMessage;
            this.$notify({
              title: "Success",
              message: response.data.StatusMessage,
              type: "success",
            });
            this.handleDeleteOnSuccess();
          } else {
            this.del_error = response.data.StatusMessage;
            this.$notify.error({
              title: "Error",
              message: response.data.StatusMessage,
            });
          }
        },
        (error) => {
          this.loading = false;
          this.del_error = error.message;
          this.$notify.error({ title: "Success", message: error.message });
        }
      );
    },

    handleCloseOnSuccess() {
      this.showLocCrSuccess = true;
      setTimeout(() => {
        this.showLocCrSuccess = false;
      }, 3000);
      this.getEvents();
    },

    handleDeleteOnSuccess() {
      setTimeout(() => {
        this.del_success = null;
      }, 3000);
      this.getEvents();
    },

    // /{organization}/event/upcomming/v1/request
    getEvents() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      axios
        .get(
          `${this.getOrganization}/event/upcomming/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.tableData = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
  },
};
</script>
